<a
  *ngIf="link.userRequired"
  (click)="popUserRequiredModal()"
  class="business-navbar__items"
  [class.business-navbar__items--active]="isActive$ | async"
  [style.padding-left.px]="calcIndentation(indentation)"
>
  <ng-content *ngTemplateOutlet="navItem"></ng-content>
</a>

<a
  *ngIf="!link.userRequired && (curServiceProviderId | async) !== link.serviceProviderId"
  [href]="link.url"
  [attr.target]="!link.openInNewTab ? null : '_blank'"
  [attr.noopener]="!link.openInNewTab ? null : ''"
  class="business-navbar__items"
  [class.business-navbar__items--active]="isActive$ | async"
  [style.padding-left.px]="calcIndentation(indentation)"
>
  <ng-content *ngTemplateOutlet="navItem"></ng-content>
</a>

<a
  *ngIf="!link.userRequired && (curServiceProviderId | async) === link.serviceProviderId"
  [routerLink]="link.path"
  class="business-navbar__items"
  [class.business-navbar__items--active]="isActive$ | async"
  [style.padding-left.px]="calcIndentation(indentation)"
>
  <ng-content *ngTemplateOutlet="navItem"></ng-content>
</a>

<ng-template #navItem>
  <div class="business-navbar__item-wrapper">
    <span class="business-navbar__item" [title]="text$ | async">
      <atlas-icon
        *ngIf="link.showIcon"
        [matIcon]="link.icon"
        [logoUrl]="link.logoUrl"
        [productName]="text$ | async"
      ></atlas-icon>
      <span class="business-navbar__item__text">{{ text$ | async }}</span>
      <ng-content></ng-content>
    </span>
  </div>
  <atlas-chip *ngIf="link.chipContent" [text]="link.chipContent | translate" [isNavChip]="true"></atlas-chip>
</ng-template>
